module.exports = __webpack_public_path__ + "staticPO/img/nibm-water-mark.712fb84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nibm-water-mark.jpg
// module id = 175m
// module chunks = 1